/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import L from "./Lang";
import './PrintView.css';
import Globals from "../shared/Globals";
import { registerPlugin } from '@capacitor/core';
import React from "react";
import {
    BleClient,
    textToDataView
  } from "@capacitor-community/bluetooth-le";

const ARMPrint = registerPlugin('ARMPrint');

export const PrintGlobal = {
    show() {},
    hide() {},
    print(data) {
        window.print();
    }
};


document.addEventListener('deviceready', function () {
    PrintGlobal.print = (data) => {
        window.cordova.plugins.printer.print(data);
    }
}, false);

export class PrintView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = { show: false, src: null, devices: [] };
        PrintGlobal.show = this.show;
        PrintGlobal.hide = this.hide;
        this.iframeRef = React.createRef();
    }

    show = (src) => {
        if(Globals.isDeviceApp()) {
            if(src.indexOf('?') >= 0)
                src += '&';
            else
                src += '?';
            src += 'isDevice=true';
        }
        this.setState({ show: true, originalSrc: src, isDevice: Globals.isDeviceApp() });
        this.getToken(src, (url) => {
            this.getContent(url);
        });
    }

    getToken = (src, callback) => {
        qreq.post('/api/token/request', {}, j => {
            if(j.item) {
                if(src.indexOf('?') > 0)
                    src += '&';
                else
                    src += '?';
                src += 'token=' + j.item;       
                this.setState({ token: j.item, src: src });
                callback?.(src);
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    getContent = (src) => {
        fetch(src, {
            method: 'GET'
        }).then(async (r) => {
            this.setState({ content: encodeURIComponent(await r.text()) });   
        }, (e) => {
            this.unkownErrorCallback();
        });
    }

    hide = () => {
        this.setState({ show: false, token: null, src: null });
    }

    // todo
    listPrinters = () => {
        window.ZebraPrinter.list(
          (printers) => {
            console.log('Available printers:', printers);
            if (printers.length === 0) alert('No printers found');
            else alert('Printers found: ' + JSON.stringify(printers));
          },
          (err) => {
            console.error('Error getting printers:', err);
            alert('Error listing printers');
          }
        );
      };

    print = async () => {
        if(Globals.isDeviceApp()) {
            const zpl = '^XA^FO100,100^ADN,36,20^FDHello Zebra^FS^XZ';
            await this.scanForDevices(async (devices) => {
                if(devices.length === 0) {
                    console.log('No devices found.');
                    return;
                }
                console.log('CONNECTING TO DEVICE', devices[0].deviceId);
                await this.connectToDevice(devices[0].deviceId);
                setTimeout(async() => {
                    console.log('PRINT MESSAGE');
                    await this.printMessage();
                }, 500);
            });

            /*
            this.getToken(this.state.originalSrc, async (url) => {
                await ARMPrint.print({ url: url });
            });
            */
        }
        else {
            window.print();
        }
    }


    

    scanForDevices = async (callback) => {

        try {
          await BleClient.initialize();
          await BleClient.requestLEScan({}, (result) => {
            if (
              result.device.name && // Only include devices with a name
              !this.state.devices.find((device) => device.deviceId === result.device.deviceId)
            ) {
                let devices = [...this.state.devices];
                this.setState({ devices: [...devices, result.device] });
                callback([...devices, result.device]);
              //setDevices((prevDevices) => [...prevDevices, result.device]);
            }
          });
    
          // Stop scanning after 5 seconds
          setTimeout(async () => {
            await BleClient.stopLEScan();
          }, 5000);
        } catch (error) {
          console.error("Error scanning for devices:", error);
        }
      }
    
      connectToDevice = async (deviceId) => {
        try {
          await BleClient.connect(deviceId);

          this.setState({ selectedDevice: deviceId });
    
          // Get services and characteristics
          const services = await BleClient.getServices(deviceId);
          if (services.length > 0) {
            services.forEach((service) => {
              console.log("Service UUID:", service.uuid);
              service.characteristics.forEach((characteristic) => {
                console.log("Characteristic UUID:", characteristic.uuid);
                console.log(
                  "Characteristic Properties:",
                  characteristic.properties
                );
    
                // Check if the characteristic supports write or writeWithoutResponse
                if (
                  characteristic.properties.write ||
                  characteristic.properties.writeWithoutResponse
                ) {
                    this.setState({ service: service, characteristic: characteristic });
                }
              });
            });
    

          } else {
            console.error("No services found on the device.");
          }
        } catch (error) {
          console.error("Error connecting to device:", error);
        }
      }
    
      printMessage = async () => {
        try {
          if (this.state.selectedDevice && this.state.service.uuid && this.state.characteristic.uuid) {
            console.log("Attempting to write to device");
            console.log("Service UUID:", this.state.service.uuid);
            console.log("Characteristic UUID:", this.state.characteristic.uuid);
            console.log("Selected device:", this.state.selectedDevice);
    
            // Add a delay after connecting to ensure the device is ready
            await new Promise((resolve) => setTimeout(resolve, 1000));
    
            const message = "Hello From Capacitor Js";
            const dataView = textToDataView(message);
    
            // Try writing to the characteristic
            try {
              await BleClient.write(
                this.state.selectedDevice,
                this.state.service.uuid,
                this.state.characteristic.uuid,
                dataView
              );
              alert("Message printed!");
            } catch (writeError) {
              console.error("Failed to write to the device:", writeError);
            }
    
            // Disconnect after writing
            await BleClient.disconnect(this.state.selectedDevice);
          } else {
            console.error("Service or characteristic UUID not set correctly.");
          }
        } catch (error) {
          console.error("Error during print:", error);
        }
      }

    render() {
        if(!this.state.show)
            return null;
        return <div className="print-view">
            {this.state.content && <iframe ref={this.iframeRef} id="print-iframe" name="print-iframe" src={'data:text/html;charset=utf-8,' + this.state.content} title="Print View" className="print-content" width="100%" border="0" />}
            <div className="print-view-footer d-flex justify-content-between d-print-none">
                <button type="button" className="btn btn-primary btn-lg" onClick={() => this.hide()}><L>Close</L></button>
                <div>
                    {this.state.devices.map((i,idx) => <span key={idx}>{i.name}</span>)} ({this.state.devices.length})
                </div>
                {this.state.isDevice && <button type="button" className="btn btn-primary btn-lg" onClick={() => this.print()} disabled={!this.state.token}><Icon icon="faPrint" /> <L>Print</L></button>}
            </div>
        </div>;
    }
}